<template>
  <div>
    <el-row v-if="goods.length > 0" :gutter="20">
      <el-col v-for="(item, index) in goods" :key="index" :xs="24" :sm="12" :md="8" :lg="6">
        <div class="goods">
          <div class="goods-thumbnail">
            <img :src="item.thumbnail_pic" alt="">
          </div>
          <div class="goods-caption">
            <div class="goods-title">
              {{item.sku_name}}
            </div>
<!--            <div class="goods-title">-->
<!--              <span style="color:blue">{{item.cat_name}}</span>-->
<!--            </div>-->
	    <div class="goods-title">{{item.sku_bn}}</div>
          </div>
          <div class="goods-remove iconfont icon-trash-alt" @click="handleSkuRemove(index)"></div>
        </div>
      </el-col>
    </el-row>
    <div>
      <el-button type="primary" @click="handleGoodsDialogShow">选择商品</el-button>
    </div>
    <GoodsSelector :single="singleData" :items-visible="itemVisible" :get-status="setItemStatus" :rel-items-ids="relItems" :item-type="item_type" @chooseStore="handleGoodsSubmit" @closeStoreDialog="handleGoodsDialogHide"></GoodsSelector>
  </div>
</template>

<script>
  import GoodsSelector from '../sharerGoodsSelect/index'
  import { getSkuList } from '../../api/sharer'

  export default {
    props: {
      data: {
        type: Array,
        default: []
      },
      limit: {
        type: Number,
        default: 0
      },
      single: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false,
        goods: [],
        current: '',
        currentPage: 1,
        skuParams: {
          page: 1,
          pageSize: 20,
          item_type: 'normal',
          approve_status: 'onsale',
          is_sku: true,
          sku_id: ''
        },
        skuTotal: 0,
        skus: [],
        checkedSkus: [],
        itemVisible: false,
        setItemStatus: false,
        relItems: [],
        item_type: 'normal'
      }
    },
    computed: {
      singleData () {
        return this.single
      }
    },
    components: {
      GoodsSelector
    },
    watch: {
      data (val) {
        this.goods = val
        this.relItems = JSON.parse(JSON.stringify(val))
        this.generateSku()
      }
    },
    methods: {
      handleGoodsDialogShow () {
        this.itemVisible = true
        this.setItemStatus = true
      },
      handleGoodsSubmit (data) {
        this.itemVisible = false
        if (data === null || data.length <= 0) return
        this.relItems = data
        let list = []
        data.forEach(item => {
            list.push(item)
        })
        this.goods = list
        this.generateSku()
      },
      generateSku () {
        let noSkuItem = []
        let response = []
        let goodsList = JSON.parse(JSON.stringify(this.goods))
        goodsList.forEach(item => {
          noSkuItem.push(item.sku_id)
        })
        if (noSkuItem.length > 0) {
          let param = this.skuParams
          param.sku_id = noSkuItem
          getSkuList(this.skuParams).then(res => {
            goodsList.forEach(item => {
                response = [...response, item]
            })
            this.$emit('change', response)
          })
        } else {
          goodsList.forEach(item => {
              response = [...response, item]
          })
          this.$emit('change', response)
        }
      },
      handleGoodsDialogHide () {
        this.itemVisible = false
      },
      handleSkuRemove (index) {
        this.goods.splice(index, 1)
        this.relItems.splice(index, 1)
        this.generateSku()
      }
    }
  }
</script>

<style lang="scss" scoped>
.el-col-lg-6 {
  width: 20%;
}
  .goods {
    display: flex;
    position: relative;
    padding: 10px;
    height: 80px;
    margin-bottom: 10px;
    transition: all 0.5s ease;
    &:hover {
      background: #f5f7fa;
      box-shadow: 0 0 3px rgba(0,0,0,0.2);
    }
  }
  .goods-thumbnail {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    margin-right: 10px;
    background: #efefef;
    box-shadow: 0 0 2px rgba(0,0,0,.2);
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .goods-caption {
    flex: 1;
    padding-right: 30px;
  }
  .goods-title {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    margin-bottom: 5px;
    width: 100%;
    max-height: 34px;
    font-size: 15px;
    line-height: 1.2;
    color: #333;
  }
  .goods-sku {
    color: #888;
  }
  .goods-sku-check {
    display: inline-block;
    margin-left: 5px;
    color: #1f82e0;
    cursor: pointer;
  }
  .goods-remove {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
    transition: all 0.5s ease;
    &:hover {
      color: #ff5000;
    }
  }
</style>



// WEBPACK FOOTER //
// sharerSkuSelector.vue?2ceaf699